export class OverlayManager {
    private viewer: Autodesk.Viewing.GuiViewer3D;
    private overlayName = 'forge-wrapper-overlay';

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.viewer = viewer;
        // create overlay
        if (!this.viewer.impl.overlayScenes[this.overlayName]) {
            this.viewer.impl.createOverlayScene(this.overlayName);
        }
    }

    addMesh(id: string, mesh: THREE.Object3D) {
        this.viewer.impl.addOverlay(this.overlayName, mesh);

        (mesh as any).__overlayId = id;
        this.viewer.impl.sceneUpdated(true);
    }

    removeMesh(mesh: THREE.Object3D) {
        this.viewer.impl.removeOverlay(this.overlayName, mesh);
        this.viewer.impl.sceneUpdated(true);
    }

    clear() {
        // crude clear - remove everything in overlay
        // Note: Viewer does not provide a direct list; this method assumes you track meshes elsewhere for removal.
        // For robust usage, store added meshes and iterate removal.
        this.viewer.impl.clearOverlay(this.overlayName);
        this.viewer.impl.sceneUpdated(true);
    }
}
